import { getUnitLabel, mergeClasses, normalizeNumber } from 'util/commons';
import styles from './CollectItem.module.scss';
import { WasteUnitItem } from 'types/routeManagementTypes';
import { IconFixedItem } from 'components/atoms/icons/IconFixedItem';
import { ItemType } from 'util/Types';
import Popover from 'components/atoms/Popover';
import { IconCheckCircle } from 'components/atoms/icons/IconCheckCircle';
import { IconPlusCircle } from 'components/atoms/icons/IconPlusCircle';
import { useTranslation } from 'react-i18next';

export const CollectItem = ({
  item,
  isEditing = false,
  onFocus,
  className,
  checked,
  onCheckedChange,
  onNoticeClick,
}: {
  item: WasteUnitItem;
  isEditing?: boolean;
  onFocus?: (item?: WasteUnitItem) => void;
  className?: string;
  checked?: boolean;
  onCheckedChange?: (item: WasteUnitItem) => void;
  onNoticeClick?: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <div
      key={item.id}
      className={mergeClasses(
        styles.item,
        {
          [styles.editing]: isEditing,
          [styles.checked]: checked,
        },
        className
      )}
      onClick={() => onFocus?.(isEditing ? undefined : item)}
    >
      <div className={styles.itemInfo}>
        <div>
          <span className={styles.itemName}>
            <Popover content={item.name} autoGen positions={['top']}>
              <span>{item.name}</span>
            </Popover>
          </span>

          {item.type === ItemType.FIX && (
            <div className={styles.fixedItemInfo}>
              <IconFixedItem color="#86ea5c" />
              <div className={styles.itemDetail}>
                <Popover
                  content={`${item.convertKg}kg/${item.quantity}${getUnitLabel(
                    item.unit
                  )}`}
                  autoGen
                  positions={['top']}
                >
                  <span>{`${item.convertKg}kg/${item.quantity}${getUnitLabel(
                    item.unit
                  )}`}</span>
                </Popover>
              </div>
            </div>
          )}
        </div>
      </div>

      <span
        className={mergeClasses(styles.itemWeight, {
          [styles.filled]: !!Number(item.weight),
        })}
      >
        {isEditing ? item.weight : normalizeNumber({ value: item.weight })}
      </span>

      {!!Number(item.weight) && onNoticeClick && (
        <button
          className={styles.reportAbnormalButton}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onNoticeClick();
          }}
        >
          {t('confirm_select_route_item.mark_abnormal')}
        </button>
      )}

      {(!Number(item.weight) || !onNoticeClick) && (
        <div className={styles.reportAbnormalButtonPlaceholder}></div>
      )}

      {!!Number(item.weight) && !!onCheckedChange && (
        <span
          className={styles.checkedIcon}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();

            onCheckedChange?.(item);
          }}
        >
          {checked ? (
            <IconCheckCircle color="#86ea5c" size={36} />
          ) : (
            <IconPlusCircle size={32} color="#4d4d4d" />
          )}
        </span>
      )}
    </div>
  );
};
